export type UserPlan = {
  exists: boolean | null;
  plan: string | null;
  canCreateRoom: boolean | null;
};

export async function checkUserPlan(userId: string): Promise<UserPlan> {
  const baseUrl = process.env.NEXT_PUBLIC_PLAN_URL;
  if (!baseUrl) throw new Error('NEXT_PUBLIC_PLAN_URL is not set');
  const url = `${baseUrl.replace(/\/$/, '')}/${encodeURIComponent(userId)}`;

  const res = await fetch(url, {
    method: 'GET',
    cache: 'no-store',
  });

  if (!res.ok) throw new Error(`checkUserPlan failed: ${res.status}`);

  const data = await res.json();
  return {
    exists: data?.exists ?? null,
    plan: data?.plan ?? null,
    canCreateRoom: data?.canCreateRoom ?? null,
  };
}
